export const PREDICTION_DESK_VIEWS = [
  { id: "all", label: "All predictions", hint: "Every fixture tip" },
  { id: "upcoming", label: "Upcoming", hint: "Future fixtures" },
  { id: "live", label: "Live", hint: "Kick-off passed" },
  { id: "past", label: "Settled", hint: "Finished fixtures" },
  { id: "premium", label: "Premium", hint: "Paid tips" },
];

export const PREDICTION_SORT_OPTIONS = [
  { value: "newest", label: "Newest first" },
  { value: "oldest", label: "Oldest first" },
  { value: "views", label: "Most views" },
  { value: "price", label: "Highest price" },
];

export function sortPredictions(predictions = [], sortKey = "newest") {
  const list = [...predictions];
  switch (sortKey) {
    case "oldest":
      return list.sort(
        (a, b) => new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime()
      );
    case "views":
      return list.sort((a, b) => (Number(b.views) || 0) - (Number(a.views) || 0));
    case "price":
      return list.sort((a, b) => (Number(b.price) || 0) - (Number(a.price) || 0));
    default:
      return list.sort(
        (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime()
      );
  }
}

export function clientFilterPredictions(predictions = [], search = "") {
  const q = search.trim().toLowerCase();
  if (!q) return predictions;
  return predictions.filter((prediction) => {
    const hay = [
      prediction.matchLabel,
      prediction.title,
      prediction.userName,
      prediction.userEmail,
      prediction.userCode,
      prediction.topOutcome,
      prediction.fixtureStatus,
      prediction.timing,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}

export function predictionRowId(prediction) {
  return String(prediction._id);
}
